import React from 'react';
import classNames from 'classnames';

import css from './DataTable.module.css';

/**
 * The shared table for Offers, Your listings and Bulk edit: inside a card, grey header row,
 * light row dividers and hover. Children are the table's own <thead> and <tbody>.
 * `caption` names the table for screen readers.
 */
const DataTable = ({ caption, className, tableClassName, children }) => (
  <div className={classNames(css.root, className)}>
    <table className={classNames(css.table, tableClassName)}>
      {caption ? <caption className="visuallyHidden">{caption}</caption> : null}
      {children}
    </table>
  </div>
);

export default DataTable;
